import { render, staticRenderFns } from "./TheWorker.vue?vue&type=template&id=baef4c48&scoped=true&"
import script from "./TheWorker.vue?vue&type=script&lang=js&"
export * from "./TheWorker.vue?vue&type=script&lang=js&"
import style0 from "./TheWorker.vue?vue&type=style&index=0&id=baef4c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baef4c48",
  null
  
)

export default component.exports